<template>
  <v-dialog v-model="dialog" max-width="850" scrollable>
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-on="on" v-bind="attrs" color="info" rounded block>
        <v-icon class="mr-2" size="18">mdi-plus</v-icon> Nova indicação</v-btn
      >
    </template>
    <manut-indicacao-pcd>
      <v-btn text rounded @click="dialog = false">Fechar</v-btn>
    </manut-indicacao-pcd>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import ManutIndicacaoPcd from "../components/ManutIndicacaoPcd.vue";
export default {
  watch: {
    dialog: function (open) {
      if (open) {
        this.indicacao.id = 0;
        this.indicacao.nome = "";
        this.indicacao.cpf = "";
        this.indicacao.dtnascimento = "";
        this.indicacao.cidade = "";
        this.indicacao.endereco = "";
        this.indicacao.telefone_pcd = "";
        this.indicacao.telefone_colaborador = "";
        this.indicacao.tiposistema = "WEB";
      }
    },
  },
  components: { ManutIndicacaoPcd },
  computed: mapState("pcd",["indicacao"]),
  data: () => ({
    dialog: false,
  }),
};
</script>

<style>
</style>